import React, {useState} from "react";
import { Navigate } from "react-router-dom";
import MainLayout from "layouts/MainLayout";
import LoginView from "views/auth/LoginView";
import Auth from "views/auth/Auth";
import Tablero from "views/Tablero";
import NotFoundView from "views/errors/NotFoundView";
import { rectSortingStrategy } from "@dnd-kit/sortable";

const routes = [
  {
    path: "/",
    element: <LoginView />,
    children: [
      { path: "404", element: <NotFoundView /> },
      {
        path: "",
        element: (
          <LoginView />
          // <Tablero itemCount={5} strategy={rectSortingStrategy} horizontal />
        ),
      },
      { path: "*", element: <Navigate to="/404" /> },
    ],

    /*
   |path: '/',
    element: <DashboardLayout />,
    children: [
      
      { path: '/', element: <Dashboard /> },
      { path: '/p', element: <Prueba /> },
      { path: '/catalogo/proveedor', element: <Proveedor /> },
      { path: '/catalogo/banco', element: <Banco /> },
      { path: '/catalogo/categoria', element: <Categorias /> },
      { path: '/catalogo/grupoInsumo', element: <GrupoInsumo /> },
      { path: '/catalogo/moneda', element: <Moneda /> },
      { path: '/catalogo/unidadMedida', element: <UnidadMedida /> },
      { path: '/catalogo/tipo', element: <Tipo /> },
      { path: '/catalogo/claveUnidad', element: <CentroCosto /> },
      { path: '/catalogo/empresa', element: <Empresa /> },
      { path: '/catalogo/insumo', element: <Insumo /> },
    ]
    */
  },
  {
    path: "/autenticacion",
    element: <Auth />,
  },
  
];

export default routes;
